import { typographyRecipe as i } from "../typography/index.mjs";
const r = i.size["sans-serif"], e = {
  borderWidth: 1,
  backgroundColor: "bg-secondary",
  borderColor: "transparent",
  borderRadius: "radius-2",
  paddingTop: "spacing-2,5",
  paddingRight: "spacing-3",
  paddingBottom: "spacing-2,5",
  paddingLeft: "spacing-3",
  gap: "spacing-2",
  color: "text-primary"
}, o = {
  borderColor: "border-error",
  backgroundColor: "bg-error-primary"
}, a = {
  ...e,
  padding: "spacing-3",
  height: "spacing-40"
}, t = {
  ...r.lg,
  color: "text-primary",
  fontWeight: "regular"
}, s = {
  sm: {
    height: "spacing-10"
  },
  md: {
    height: 44
  },
  lg: {
    height: "spacing-14"
  },
  xl: {
    height: "spacing-16",
    ...r["3xl"]
  }
}, n = {
  sm: {
    height: "spacing-15"
  },
  md: {
    height: "spacing-20"
  },
  lg: {
    height: "spacing-40"
  },
  xl: {
    height: "spacing-180"
  }
};
export {
  e as base,
  o as baseError,
  a as baseTextArea,
  t as inputText,
  s as size,
  n as sizeTextArea
};
